// extracted by mini-css-extract-plugin
module.exports = {"MatomoOptOut":"MatomoOptOut_MatomoOptOut__wQ5_P"};